'use strict';

// Create a DOMPurify instance bound to the current window and expose it globally
import createDOMPurify from 'dompurify';

const DOMPurify = createDOMPurify(window);

// Make available as a global the same way we do for other external libs
export default (window.DOMPurify = DOMPurify);
